import React from 'react'
import SideBar from '../components/SideBar';

const DeckPal = () => {
  return (
    <main>
      <div className="SideBar">
        <SideBar />
      </div>
      <div className="FilterContainer" id="Error">
        <section className="section about-section">
          <h1 className="section-title">Deck</h1>
          <p>
            Exercitation ullamco sint aliqua incididunt esse ut aute duis est
            ullamco nostrud velit anim Lorem. Dolore adipisicing amet ipsum sit.
            Voluptate proident eiusmod sunt do aliqua ad pariatur aute
            reprehenderit pariatur.
          </p>
        </section>
      </div>
    </main>
  );
}

export default DeckPal
